import React from 'react';
import { TXProvider } from '@transifex/react';
import { useTXManager } from '../../hooks/useTXManager';
export const TransifexManager = ({ tag, token, children }) => {
    const txManager = useTXManager(tag, token);
    const txInstance = txManager === null ? undefined : txManager.txInstance;
    return React.createElement(TXProvider, { instance: txInstance }, children);
};
